module.exports = __webpack_public_path__ + "static/nureva-logo-aefa5cc49bf29b3002ed4f937e37f3ec.png";